const YOUTUBE_HOSTS = [
	'youtube.com',
	'www.youtube.com',
	'youtu.be',
	'm.youtube.com',
]

const VIMEO_HOSTS = ['vimeo.com', 'www.vimeo.com', 'player.vimeo.com']

const YOUTUBE_ALLOWED_PARAMS = ['v', 't', 'start', 'end', 'si']

const VIMEO_ALLOWED_PARAMS = ['h', 't']

const HAS_SCHEME = /^[a-z][a-z0-9+.-]*:\/\//i

// A dotted host before any path, so half-typed input ("you") is left alone
// instead of being rewritten to "https://you" when the field blurs.
const LOOKS_LIKE_HOST = /^[^\s/?#]+\.[^\s/?#]+/

function stripParams(parsed: URL, allowedParams: string[]): string {
	const keysToRemove: string[] = []
	parsed.searchParams.forEach((_value, key) => {
		if (!allowedParams.includes(key)) {
			keysToRemove.push(key)
		}
	})
	for (const key of keysToRemove) {
		parsed.searchParams.delete(key)
	}
	return parsed.toString()
}

export function sanitizeVideoUrl(url: string): string {
	if (!url) return url

	// MYQRCODE-10758 - schemeless input like "sss.dzs" passes the field's isURL
	// check but would be stored as a relative link, so normalize it first.
	const normalized =
		HAS_SCHEME.test(url) || !LOOKS_LIKE_HOST.test(url)
			? url
			: `https://${url}`

	let parsed: URL
	try {
		parsed = new URL(normalized)
	} catch {
		return url
	}

	if (YOUTUBE_HOSTS.includes(parsed.hostname)) {
		return stripParams(parsed, YOUTUBE_ALLOWED_PARAMS)
	}

	if (VIMEO_HOSTS.includes(parsed.hostname)) {
		return stripParams(parsed, VIMEO_ALLOWED_PARAMS)
	}

	return normalized
}
